Game.Utils.callbacks = {

	exitLevel: function( zone ) {

		if ( Game.Utils.Hud.coins.getValue() >= 200 ) {

			if ( 'open' === zone.door.state ) {
				return;
			}

			zone.door.open();

			Game.Utils.ManageDoors.unlockDoor( zone.name );

		}

	},

};